import { Box,Modal } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MButton } from "../../../../components/button";
import { SalesMode } from "../../contexts/SalesModeContext";
import styles from "./ModeSwitchConfirmModal.module.scss";

interface ModeSwitchConfirmModalProps {
    open: boolean;
    pendingMode: SalesMode | null;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ModeSwitchConfirmModal = ({ open, pendingMode, onConfirm, onCancel }: ModeSwitchConfirmModalProps) => {
    const { t } = useTranslation();

    const getModeName = (targetMode: SalesMode | null) => {
        if (!targetMode) return "";
        return targetMode === "ordering" ? t("點餐模式") : t("SALES.ExhibitionMode");
    };

    return (
        <Modal open={open} onClose={onCancel}>
            <Box className={styles.modalContainer}>
                <h3 className={styles.title}>{t("COMMON.Confirm") || "確認"}</h3>
                <p className={styles.message}>
                    {t("是否切換至")} <strong>{getModeName(pendingMode)}</strong>？
                </p>
                <Box className={styles.actions}>
                    <MButton variant='outlined' btnText={t("COMMON.Cancel") || "取消"} onClick={onCancel} />
                    <MButton
                        variant='contained'
                        color='primary'
                        btnText={t("COMMON.Confirm") || "確認"}
                        onClick={onConfirm}
                    />
                </Box>
            </Box>
        </Modal>
    );
};
